// Routes for testing disaster recovery

export const currentConn ="TESTDR";
export const baseUrlTest = 'https://test.trmsdr.com/';
export const baseUrlStaging = 'https://staging.trmsdr.com/';
export const baseUrlProd = 'https://trmsdr.com/';
export const baseUrlDeployProdA = 'https://deploya.trmsdr.com/';
export const baseUrlDeployProdB =  'https://deployb.trmsdr.com/';
